import React, { FC } from "react";

import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { TProductIntroProps } from "./types/ProductIntro.types";
import { ProductIntroModel } from "./models/ProductIntro.model";

import "./style.scss";

const ProductIntro: FC<TProductIntroProps> = (props) => {
  const model = new ProductIntroModel(props);

  return (
    <section
      className="product-intro"
      id={props?.fields?.apiData?.id?.toString()}
    >
      <div className="product-intro__container">
        <img
          src={model.image}
          alt={model?.imageAlt || ""}
          className="product-intro__image"
        />
        <div className="product-intro__info">
          <div className="product-intro__info__eyebrow">EXPLORE THE MODEL</div>
          <h1>{model.title}</h1>
          <RichText
            field={{ value: model.description }}
            editable={false}
            tag="div"
          />
        </div>
      </div>
    </section>
  );
};

export default ProductIntro;
